const modal = {
  hu: {
    gift_for_you: "Ajándék az Ön számára 🎁",
    discount_challenge_title: "Szerezzen {value}% kedvezményt",
    discount_challenge_text:
      "Adja meg e-mail címét az alábbiakban, hogy {value}% kedvezményt kapjon az első rendeléséből. 🎁",
    discount_challenge_primary_btn: "Kérem {value}% kedvezményt",
    discount_challenge_link:
      'Az űrlap kitöltésével Ön hozzájárul személyes <a href="{link}" target="_blank" class="discount-popup__link"> adatainak feldolgozásához </a>.',
    discount_challenge_secondary_btn: "Folytatás kedvezmény nélkül.",
    discount_thanks_title: "Köszönjük",
  },
  sk: {
    remove_file_title: "Naozaj chcete odstrániť súbor?",
    remove_file_text:
      "Po odstranení bude súbor odstránený z produktového editora",
    remove_confirm: "Áno, chcem odstrániť",
    remove_product_title: "Naozaj chcete odstrániť produkt?",
    remove_product_text: "Po odstranení bude produkt vymazaný z košíka",
    Close: "Zatvoriť",
    discount_challenge_title: "Získajte {value}% zľavu",
    discount_challenge_text:
      "Zadajte nižšie svoj email, na ktorý vám zašleme <strong>bezkonkurečnú {value}% zľavu</strong> na vašu prvú objednávku 🎁",
    discount_challenge_primary_btn: "Chcem {value}% zľavu",
    discount_challenge_secondary_btn: "Nie, ďakujem zaplatím plnú sumu.",
    discount_challenge_link:
      'Vyplnením formulára súhlasíte so <a href="{link}" target="_blank" class="discount-popup__link"> spracovaním osobných údajov </a>.',
    discount_thanks_title: "Ďakujeme",
    discount_thanks_text1: "Email so zľavovým kódom vám zachvíľku odošleme 🤩",
    discount_thanks_text2:
      'Ak ho nebudete vidieť, nezabudnite si skontrolovať schránky ako napríklad "spam".',
    gift_for_you: "Darček pre Vás 🎁",
  },
  cs: {
    remove_file_title: "Opravdu chcete odstranit soubor?",
    remove_file_text:
      "Po odstranění bude soubor odstraněn z produktového editoru",
    remove_confirm: "Ano, chci odstranit",
    remove_product_title: "Opravdu chcete odstranit produkt?",
    remove_product_text: "Po odstranění bude produkt vymazán z košíku",
    Close: "Zavřít",
    discount_challenge_title: "Získejte {value}% slevu",
    discount_challenge_text:
      "Zadejte níže svůj email, na který vám zašleme <strong>bezkonkurenční {value}% slevu</strong> na vaši první objednávku 🎁",
    discount_challenge_primary_btn: "Chci {value}% slevu",
    discount_challenge_secondary_btn: "Ne, děkuji zaplatím plnou částku.",
    discount_challenge_link:
      'Vyplněním formuláře souhlasíte se <a href="{link}" target="_blank" class="discount-popup__link">zpracováním osobních údajů</a>.',
    discount_thanks_title: "Děkujeme",
    discount_thanks_text1: "Email se slevovým kódem vám zachvilku odešleme 🤩",
    discount_thanks_text2:
      'Pokud jej nebudete vidět, nezapomeňte si zkontrolovat schránky jako například "spam".',
    gift_for_you: "Dárek pro Vás 🎁",
  },
};

export default modal;
